export interface Atributo {
  id: number;
  categoria_id?: number;
  nome: string;
  compoe_nome: boolean;
  obrigatorio: boolean;
  tipo: string;
  ordem_nome: number;
}

export interface CategoriaHierarquica {
  id: number;
  nome: string;
  atributos: Atributo[];
  ordem: number[];
  subcategorias: CategoriaHierarquica[];
}

export interface CategoriaAchatada {
  id: number;
  nome: string;
  atributos: Atributo[];
  pathLabel: string;
  atributosCompletos: Atributo[];
}

export const encontrarCaminhoNaArvore = (
  categorias: CategoriaHierarquica[],
  idBuscado: number,
  caminho: CategoriaHierarquica[] = []
): CategoriaHierarquica[] | null => {
  for (const categoria of categorias) {
    const novoCaminho = [...caminho, categoria];

    if (categoria.id === idBuscado) {
      return novoCaminho;
    }

    if (categoria.subcategorias?.length) {
      const resultado = encontrarCaminhoNaArvore(categoria.subcategorias, idBuscado, novoCaminho);
      if (resultado) return resultado;
    }
  }

  return null;
};

export const encontrarCategoriaPorId = (
  categorias: CategoriaHierarquica[],
  idBuscado: number
): CategoriaHierarquica | null => {
  for (const categoria of categorias) {
    if (categoria.id === idBuscado) {
      return categoria;
    }

    if (categoria.subcategorias?.length) {
      const resultado = encontrarCategoriaPorId(categoria.subcategorias, idBuscado);
      if (resultado) return resultado;
    }
  }

  return null;
};

export const flattenCategories = (
  categories: CategoriaHierarquica[],
  parentPath: string[] = [],
  parentAtributos: Atributo[] = []
): CategoriaAchatada[] => {
  return categories.flatMap(category => {
    const currentPath = [...parentPath, category.nome];
    const pathLabel = currentPath.join(" > ");

    const atributosAcumulados = [...parentAtributos, ...(category.atributos || [])];

    return [
      {
        id: category.id,
        nome: category.nome,
        atributos: category.atributos || [],
        pathLabel,
        atributosCompletos: atributosAcumulados
      },
      ...flattenCategories(category.subcategorias || [], currentPath, atributosAcumulados)
    ];
  });
};

export const formatarCaminhoCompleto = (caminho: CategoriaHierarquica[]): string => {
  return caminho.map(c => c.nome).join(" > ");
};

export const coletarAtributosHerdados = (caminho: CategoriaHierarquica[]): Atributo[] => {
  const atributosUnicos = new Map<number | string, Atributo>();

  caminho.forEach(categoria => {
    categoria.atributos?.forEach((atributo: Atributo) => {
      const chave = atributo.id || atributo.nome;
      if (!atributosUnicos.has(chave)) {
        atributosUnicos.set(chave, atributo);
      }
    });
  });

  return Array.from(atributosUnicos.values());
};
